export default {
  'version': '1.1',
  'xmlns': 'http://www.w3.org/2000/svg',
  'xmlns:xlink': 'http://www.w3.org/1999/xlink'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/util/svg/metadata.js
// module id = 341
// module chunks = 0